import React from "react";
import { Box, Typography } from "@mui/material";

function getToneColors(state) {
  if (state === "drift") {
    return { fill: "#d49a4a", track: "rgba(255,255,255,0.16)", inner: "rgba(6,31,58,0.78)", text: "#ffffff", subtext: "rgba(248,251,255,0.72)" };
  }
  if (state === "reentry") {
    return { fill: "#37c283", track: "rgba(255,255,255,0.16)", inner: "rgba(6,31,58,0.78)", text: "#ffffff", subtext: "rgba(248,251,255,0.72)" };
  }
  if (state === "dormant") {
    return { fill: "#94a3b8", track: "rgba(255,255,255,0.16)", inner: "rgba(6,31,58,0.78)", text: "#ffffff", subtext: "rgba(248,251,255,0.72)" };
  }
  return { fill: "#37c283", track: "rgba(255,255,255,0.16)", inner: "rgba(6,31,58,0.78)", text: "#ffffff", subtext: "rgba(248,251,255,0.72)" };
}

export default function MomentumRing({ value, total = 7, label, state = "active", updatedToday = false }) {
  const safeTotal = total || 1;
  const displayValue = Number.isFinite(Number(value)) ? Math.max(0, Math.round(Number(value))) : 0;
  const progress = Math.max(0, Math.min(1, displayValue / safeTotal));
  const { fill, track, inner, text } = updatedToday
    ? { fill: "#37c283", track: "rgba(255,255,255,0.16)", inner: "rgba(6,31,58,0.78)", text: "#ffffff", subtext: "rgba(248,251,255,0.72)" }
    : getToneColors(state);
  const angle = `${Math.round(progress * 360)}deg`;
  const digitCount = String(displayValue).length;
  const numberFontSize =
    digitCount >= 4
      ? { xs: "1.02rem", md: "1.18rem" }
      : digitCount === 3
        ? { xs: "1.18rem", md: "1.36rem" }
        : { xs: "1.36rem", md: "1.6rem" };

  return (
    <Box
      aria-label={`${displayValue} ${label || `of ${safeTotal} days`}`}
      sx={{
        position: "relative",
        width: { xs: 76, md: 88 },
        height: { xs: 76, md: 88 },
        borderRadius: "50%",
        background: `conic-gradient(${fill} ${angle}, ${track} ${angle})`,
        display: "grid",
        placeItems: "center",
        flexShrink: 0,
        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.08)",
      }}
    >
      <Box
        sx={{
          width: { xs: 56, md: 64 },
          height: { xs: 56, md: 64 },
          borderRadius: "50%",
          backgroundColor: inner,
          border: "1px solid rgba(255,255,255,0.10)",
          display: "grid",
          placeItems: "center",
          textAlign: "center",
          overflow: "hidden",
          px: 0.25,
        }}
      >
        <Typography variant="h3" sx={{ fontWeight: 900, color: text, lineHeight: 1, fontSize: numberFontSize, fontVariantNumeric: "tabular-nums" }}>
          {displayValue}
        </Typography>
      </Box>
    </Box>
  );
}
